export default "__VITE_ASSET__DlyFwqmw__"